import React from "react";
import Seehero from "../components/seemore/seehero/seehero";
import Seemid from "../components/seemore/seemid/seemid";
import Seebot from "../components/seemore/seebot/seebot";
import Benefits from "../components/NewHome/Benefits/Benefits";
import SeeMore from "../components/seemore/newseemore/SeeMore";

const Seemore = () => {
  return (
    <div>
      <SeeMore />
      {/* <Seehero />
      <Seemid />
      <Seebot /> */}
    </div>
  );
};

export default Seemore;
